import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { OnboardingRoot, Tooltips } from '@pages/common/Onboarding/store/onboarding-types';
import type { TooltipsStatusesEnum } from '@pages/common/OnboardingTooltip/const/tooltips-statuses.enum';
import type { Nullable } from '@shared/types/base-custom.type';

const onboardingSetupSlice = createSlice({
  name: 'onboardingSlice',
  initialState: {
    onboardingSetupData: null as Nullable<OnboardingRoot>,
    isLoadingOnboardingSetup: false,
    onboardingSetupComplete: 0,
    isCompleteProcessAnimation: false,

    // --------------- onboarding-tooltip ------------
    tooltips: null as Tooltips | null,
  },
  reducers: {
    setLoadingOnboardingSetup(state, action: PayloadAction<{ isLoading: boolean }>) {
      state.isLoadingOnboardingSetup = action.payload.isLoading;
    },
    setOnboardingCompleteAnimation(state, action: PayloadAction<{ isComplete: boolean }>) {
      state.isCompleteProcessAnimation = action.payload.isComplete;
    },
    setOnboardingSetupProcess(state, action: PayloadAction<{ process: number }>) {
      state.onboardingSetupComplete = action.payload.process;
    },

    setOnboardingSetupData(state, action: PayloadAction<{ onboardingData: Nullable<OnboardingRoot> }>) {
      state.onboardingSetupData = action.payload.onboardingData;
    },

    // --------------- onboarding-tooltip ------------
    updateEntityOnboardingTooltip(
      state,
      action: PayloadAction<{ entity: keyof Tooltips; status: TooltipsStatusesEnum }>,
    ) {
      const { entity, status } = action.payload;

      if (state.tooltips) {
        state.tooltips = {
          ...state.tooltips,
          [entity]: status,
        };
      } else {
        state.tooltips = {
          [entity]: status,
        } as Tooltips;
      }
    },

    setEntityOnboardingTooltip(state, action: PayloadAction<{ tooltips: Tooltips }>) {
      if (action.payload.tooltips && typeof action.payload.tooltips === 'object') {
        state.tooltips = action.payload.tooltips;
      } else {
        return;
      }
    },
  },
});

export const {
  setLoadingOnboardingSetup,
  setOnboardingSetupData,
  setOnboardingSetupProcess,
  setOnboardingCompleteAnimation,

  // --------------- onboarding-tooltip ------------
  updateEntityOnboardingTooltip,
  setEntityOnboardingTooltip,
} = onboardingSetupSlice.actions;

export const onboardingSetupReducer = onboardingSetupSlice.reducer;
